<template>
  <span class="finance-status-tag" :class="`finance-status-tag--${status.tone}`">{{ status.label }}</span>
</template>

<script setup>
import { computed } from 'vue'
import { financeRecordStatus } from '../utils/financeRecordStatus.js'

const props = defineProps({
  type: { type: String, required: true },
  record: { type: Object, required: true },
})
const status = computed(() => financeRecordStatus(props.type, props.record))
</script>

<style scoped>
.finance-status-tag {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: 3px 9px;
  border: 1px solid #dfe5ed;
  border-radius: 6px;
  color: #68788e;
  background: #f1f4f8;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
}
.finance-status-tag--success { color: #16835b; background: #eaf8f0; border-color: #bfe7cf; }
.finance-status-tag--failed { color: #c44249; background: #fff0f0; border-color: #f4c7ca; }
.finance-status-tag--pending { color: #217bb8; background: #edf7ff; border-color: #cbe5f8; }
</style>
